module.exports = __WEBPACK_EXTERNAL_MODULE_13__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/add/operator/map"
// module id = 13
// module chunks = 0